var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.953,
    height: 26.947,
    viewBox: "0 0 23.953 26.947",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#6a709f;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-88.093 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M24.21,5.069V6.491a3.747,3.747,0,0,1-3.743,3.743H11.485A3.747,3.747,0,0,1,7.743,6.491V5.069A4.483,4.483,0,0,0,4,9.485v14.97a4.491,4.491,0,0,0,4.491,4.491H23.462a4.491,4.491,0,0,0,4.491-4.491V9.485A4.483,4.483,0,0,0,24.21,5.069Zm-8.234,8.907a2.994,2.994,0,1,1-2.994,2.994,2.994,2.994,0,0,1,2.994-2.994ZM21.965,27.45H9.988a1.5,1.5,0,0,1-1.5-1.5,2.994,2.994,0,0,1,2.994-2.994h8.982a2.994,2.994,0,0,1,2.994,2.994,1.5,1.5,0,0,1-1.5,1.5ZM9.988,6.491v-1.5h2.994a2.994,2.994,0,0,1,5.988,0h2.994v1.5a1.5,1.5,0,0,1-1.5,1.5H11.485A1.5,1.5,0,0,1,9.988,6.491Z",
    transform: "translate(84.093 0)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.575d8625179e8c9f6d11867b9b2ee0a5.svg";
export { ForwardRef as ReactComponent };